<template>
    <div>
        <HeaderComponent />
    </div>
</template>

<script>
    import HeaderComponent from '@/components/RecruitmentPage/HeaderComponent'

    export default {
        name: "Recruitment",
        components: {
            HeaderComponent
        }
    }
</script>

<style scoped>

</style>
